// Builds a small preview thumbnail for the "My Maps" list from any image source
// (a data URL or a Blob). Downscaled + JPEG-encoded so the list loads fast, and
// flattened onto a background because several tools render transparent PNGs.

const loadImg = (src) =>
    new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error('Failed to load image for thumbnail'));
        img.src = src;
    });

export const makeThumbnail = async (source, { max = 480, background = '#ffffff' } = {}) => {
    const isBlob = typeof source !== 'string';
    const url = isBlob ? URL.createObjectURL(source) : source;
    try {
        const img = await loadImg(url);
        const w0 = img.naturalWidth || img.width;
        const h0 = img.naturalHeight || img.height;
        const scale = Math.min(1, max / Math.max(w0, h0));
        const w = Math.max(1, Math.round(w0 * scale));
        const h = Math.max(1, Math.round(h0 * scale));

        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        if (background) {
            ctx.fillStyle = background;
            ctx.fillRect(0, 0, w, h);
        }
        ctx.drawImage(img, 0, 0, w, h);

        return await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.82));
    } finally {
        if (isBlob) URL.revokeObjectURL(url);
    }
};
